/**
 * PRH main business line is stored per language. Public pages must not fall back to Finnish
 * copy on English (or Swedish) URLs — that hurts UX/SEO and diverges from job detail behaviour.
 */
export type RegistryMainBusinessLineFields = {
  registryMainBusinessLineDescriptionEn?: string | null;
  registryMainBusinessLineDescriptionFi?: string | null;
  registryMainBusinessLineDescriptionSv?: string | null;
};

export function resolveRegistryMainBusinessLineForPageLocale(
  fields: RegistryMainBusinessLineFields,
  pageLocale: string,
): string {
  const en = (fields.registryMainBusinessLineDescriptionEn ?? '').trim();
  const fi = (fields.registryMainBusinessLineDescriptionFi ?? '').trim();
  const sv = (fields.registryMainBusinessLineDescriptionSv ?? '').trim();
  const loc = pageLocale.toLowerCase();

  if (loc === 'fi') {
    return fi || en || '';
  }
  if (loc === 'sv') {
    return sv || en || '';
  }
  // English and any other locale: show English registry text only (never Finnish).
  return en;
}
